import API, {APIRequestConfig} from "../API"
import setIfNotSet from "../../setIfNotSet"
import {getGraphError} from "../API/utils/errorHandler/getGraphError"
import getUrl from "./utils/getUrl"
import appendApolloClientValues from "./utils/appendApolloClientValues"

export interface GraphRequest {
  query: any
  variables?: Record<string, any>
  operationName?: string
}

const graph = async ({query, variables, operationName}: GraphRequest, options: APIRequestConfig = {}) => {
  setIfNotSet(options, "isGraphQuery", true)
  await appendApolloClientValues(options)

  const {data} = await API.post(getUrl(), {query, variables, operationName}, options)

  if (data.errors) throw getGraphError(data.errors, operationName)

  return data.data
}

export default graph
export {getUrl}
